import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Nav, PDFButton, BookmarkButton, Filter } from '../../../components'
import Router from './../../../services/Router'
import { NewsStyle, NewsCardStyle, ButtonLoadMoreStyle } from '../../../styles'
import { withLoader } from '../../../hoc/withLoader'
import { Date_FR } from './../../../helpers/date'

 
class Publications extends Component {
  state = {
    nav: [
      {
        value: 'Publications',
        url: Router.publications.path
      },
      {
        value: 'Social Wall',
        url: `${Router.social.exactPath}/instagram`
      },
    ],
    isFiltering: [],
    count: 6,
  }

  componentWillReceiveProps ({data}) {
    if ( data !== this.props.data ) {
      const years = []
      const isExist = []
      data.news.map((news) => {
        if (isExist.indexOf(news.year) === -1) {
          isExist.push(news.year)
          years.push({name: news.year, checked: false})
        }
      })
      this.setState({filters: {year: years}})
    }
  }

  getFilters = (filters) => {
    const isFiltering = []
    if (filters.year && filters.year.length > 0) {
      filters.year.map((item) => {
        isFiltering.push(item)
      })  
    }
    this.setState({ isFiltering })
  }

  getMore = () => {
    this.setState({ count: this.state.count + 6 })
  }

  render () {
    const { 
      nav,
      filters,
      isFiltering,
      count
    } = this.state

    const { data, isReady } = this.props
    return (
      <div className={`${NewsStyle} ${ButtonLoadMoreStyle}`}>
        <div className="page-inner">
          <div className="publication-nav">
            <Nav nav={nav} />
          </div>
          <div className={`transition ${isReady ? 'transition--ready': ''}`}>
            {
              data && Object.keys(data.spotlight).length > 0 && (
              <div className='publication-spotlight'>
                <h2 className="spotlight-title">In the Spotlight</h2>
                <div className={`spotlight-news news ${NewsCardStyle(data.spotlight.picture)}`}>
                  <Link to={data.spotlight.slug}>
                    <div className="news-head flex">
                      <div className="news-info">
                        <div className="news-date"> { Date_FR(data.spotlight.date) } </div>
                        <div className="news-title"> {data.spotlight.title} </div>
                      </div>
                      <div className="news-right">
                        <span className="news-link"> Read more </span>
                        <div className="news-button flex">
                          { data.spotlight.pdf && (
                            <PDFButton big pdfs={data.spotlight.pdf} />
                            ) 
                          }
                          { 
                            data.spotlight.slug_bookmark && 
                            <BookmarkButton item={{slug_bookmark: data.spotlight.slug_bookmark , type: data.spotlight.type}} is_bookmark={data.spotlight.is_bookmark} big/>
                          }
                        </div>
                      </div>
                    </div>
                    <div className="news-picture"></div>
                  </Link>
                </div>
              </div>
              )
            }
          
            <div className="publication-list">
              <div className="publication-filter">
              {
                filters && (
                  <div className="catalog-filter">
                    <Filter filters={filters} filtering={this.getFilters} />
                  </div>
                )
              }
              </div>
              {
                data && data.news && data.news.filter(item => (isFiltering.length > 0 && isFiltering.indexOf(item.year.toString()) !== -1) || isFiltering.length === 0 )
                .slice(0, count)
                .map((item, index) => (
                  <div className={ `news card ${NewsCardStyle(item.cover)}`} key={index}>
                    <Link to={item.slug} className='flex'>
                      <div className="news-picture"></div>
                      <div className="news-info">
                        <div className="news-date"> {item.data.slice(0,10)} </div>
                        <div className="news-title"> {item.title} </div>
                        <span className="news-link"> Read more </span>
                      </div>
                      <div className="news-button">
                        { item.pdf && (
                          <PDFButton big pdfs={item.pdf} />
                          ) 
                        }
                        { 
                          item.slug_bookmark && 
                          <BookmarkButton item={{slug_bookmark: item.slug_bookmark , type: item.type}} is_bookmark={item.is_bookmark} big/>
                        }
                      </div>
                    </Link>
                  </div>
                ))
              }
              {
              data && data.news && count < data.news.length && (
                <button type="button" className="btn btn-load-more" onClick={ this.getMore }>
                  Load more
                </button>
              )
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withLoader(Publications, '/news')


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Publication.js